import { IApplicationState } from '../../types/redux';
import { ESortType } from '../../types/sort';

export const getActiveSortValue = (state: IApplicationState): ESortType | null => {
  const sort = state.sort.find(item => item.isSelected);

  return sort?.type ?? null;
};
